import { render } from "./MaterialAlerts.vue?vue&type=template&id=263f5a20&scoped=true"
import script from "./MaterialAlerts.vue?vue&type=script&lang=js"
export * from "./MaterialAlerts.vue?vue&type=script&lang=js"

import "./MaterialAlerts.vue?vue&type=style&index=0&id=263f5a20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-263f5a20"]])

export default __exports__